import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { ISidePanelProps } from './ISidePanelProps';
import { usePanelWidth } from './usePanelWidth';

/**
 * Бічна панель сторінки запису (UIUX forms/side-panels, прототип v4): роздільник 8px (тягнути — ширина, подвійний клік — типова),
 * панель 380px (260–720, не більше 60%) зі шапкою «назва · підзаголовок · ×» і вмістом, що прокручується; Esc закриває, коли фокус у панелі.
 */
export function SidePanel({ title, subtitle, onClose, children }: ISidePanelProps) {
  const { t } = useTranslation();
  const { width, start, reset } = usePanelWidth();
  const aside = useRef<HTMLElement>(null);
  const close = useRef(onClose);
  useEffect(() => { close.current = onClose; }, [onClose]);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && aside.current?.contains(document.activeElement)) close.current(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
  return (
    <>
      <div className="rec-split" role="separator" aria-orientation="vertical" aria-label={t('recordPage.advisoryPanel.resize')} title={t('recordPage.advisoryPanel.resize')}
        onMouseDown={start} onDoubleClick={reset}><span /></div>
      <aside ref={aside} className="rec-panel" aria-label={title} style={{ width }}>
        <div className="rec-panel__head">
          <div className="rec-panel__titles"><strong>{title}</strong><span>{subtitle}</span></div>
          <button type="button" className="rec-panel__close" aria-label={t('recordPage.advisoryPanel.close')} title={t('recordPage.advisoryPanel.close')} onClick={onClose}>×</button>
        </div>
        <div className="rec-panel__body">{children}</div>
      </aside>
    </>
  );
}
